import * as L from 'leaflet';
import { addClassNames } from './lib/utils/dom';
/**
 * The  GridAPI error control's default options.
 */
const CONTROL_GRID_API_ERROR_OPTIONS_DEFAULT = {
    position: 'topleft',
};
/**
 * The GirdAPI error control.
 */
export class ControlGridAPIError extends L.Control {
    /**
     * Create a new GridAPI error control instance.
     * @param options - The GridAPI error control options.
     */
    constructor(options) {
        super(Object.assign(Object.assign({}, CONTROL_GRID_API_ERROR_OPTIONS_DEFAULT), options));
    }
    /**
     * Hook to execute when control is added to the map.
     * @returns The control's container.
     * @see {@link https://leafletjs.com/reference-1.7.1.html#control-extension-methods}
     */
    onAdd() {
        const container = L.DomUtil.create('div', 'layer-gridapi-error');
        container.style.display = 'none';
        return container;
    }
    /**
     * Hook to execute when control is removed from the map.
     * @see {@link https://leafletjs.com/reference-1.7.1.html#control-extension-methods}
     */
    onRemove() {
        // do nothing
    }
    /**
     * Set a message to display in the error control.
     * @param message - The message to show.
     */
    setMessage(message) {
        if (this._container) {
            if (message === null) {
                this._container.style.display = 'none';
                this._container.innerHTML = '';
            }
            else {
                this._container.style.display = 'block';
                this._container.innerHTML = message;
            }
        }
    }
    /**
     * Add the error control's custom markup.
     */
    addCustomMarkup() {
        if (this._container) {
            addClassNames(this._container, ['maap_c-control', 'maap_c-floating']);
        }
    }
}
//# sourceMappingURL=ControlGridAPIError.js.map